<template>
  <div id="app">
    <router-view />
    <ModalCgu
      :isManagerOrOwner="owner"
      v-show="!cgu && cguLoaded"
      @close="acceptCgu()"
      @openCGU="isCguContentDisplay = true"
    />
    <ModalContentCgu v-show="isCguContentDisplay" @close="isCguContentDisplay = false" />
  </div>
</template>

<script lang="javascript">
import rangeStore from '@Store/modules/store.range.js';
import quizzStore from '@Store/modules/store.quizz.js';
import webControlStore from '@Store/modules/store.webControl.js';
import visonCategory from '@Store/modules/store.UnderstandVideo.js';
import storeMedia from '@Store/modules/store.media.js';
import storeProduct from '@Store/modules/store.product.js';
import Api from './services/Api.js';
import ModalCgu from './components/Menus/ModalCgu';
import ModalContentCgu from './components/Menus/ModalContentCgu';

export default {
  watch: {
    $route() {
      if (window.sessionStorage.getItem('storeId')) {
        this.$gtag.event('Store ID', {
          event_label: window.sessionStorage.getItem('storeId'),
          value: window.sessionStorage.getItem('storeId'),
        });
      }
    },
  },
  components: { ModalContentCgu, ModalCgu },
  created: function() {
    Api.initAxios();

    this.$store.registerModule('rangeStore', rangeStore);
    this.$store.registerModule('quizzStore', quizzStore);
    this.$store.registerModule('webControlStore', webControlStore);
    this.$store.registerModule('visonCategory', visonCategory);
    this.$store.registerModule('mediaStore', storeMedia);
    this.$store.registerModule('productStore', storeProduct);
    this.$store.dispatch('resetState');
    this.$store.subscribe(() => {
      if (this.$route.name !== 'Callback') {
        this.cguLoaded = true;
      }
    });
  },
  beforeDestroy: function() {
    this.$store.unregisterModule('rangeStore');
    this.$store.unregisterModule('quizzStore');
    this.$store.unregisterModule('webControlStore');
    this.$store.unregisterModule('visonCategory');
    this.$store.unregisterModule('mediaStore');
    this.$store.unregisterModule('productStore');
  },
  mounted() {
    this.$store.watch(
            (state, getters) => getters.userIsSet,
            newValue => {
              if (newValue)
              this.loadStore();
            });
    if (window.sessionStorage.getItem('storeId')) {
      this.loadStore();
    }
  },
  beforeMount() {},
  data: () => {
    return {
      owner: false,
      cgu: true,
      cguLoaded: false,
      isCguContentDisplay: false,
    };
  },
  computed: {
    isCguAccepted() {
      return !!sessionStorage.getItem('cgu');
    },
    isOwner() {
      return sessionStorage.getItem('userRole') === 'OWNER';
    },
  },
  methods: {
    loadStore() {
      this.$store.dispatch('loadProducts').then(() => {
        const splitPath = this.$route.fullPath.split('/');
        if (this.$route.query.embed === 'true' && splitPath.length >= 2 && splitPath[1] === 'demos') this.cgu = true;
        else {
          this.owner = this.isOwner;
          this.cgu = this.isCguAccepted;
        }
      });
      this.$store.dispatch('loadValues');
      this.$store.dispatch('loadVideoLinks');
      this.$store.dispatch('loadMedias');
      this.$store.dispatch('loadProductsEssilor');
    },
    acceptCgu() {
      this.$store.dispatch('acceptCgu').then(() => {
        window.location = window.location;
      });
    },
  },
};
</script>

<style>
@keyframes anim-overflow {
  0% {
    opacity: 0;
    max-height: 0;
    overflow-y: hidden;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    max-height: 999px;
    overflow-y: auto;
  }
}

@keyframes anim-opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* REGULAR */
@supports not (-ms-high-contrast: none) {
  /* Non-IE styles */
  @font-face {
    font-family: 'AkhandSoft';
    src: url(fonts/AkhandSoft-Regular.otf) format('truetype');
  }
}
@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'AkhandSoft';
  src: url(fonts/AkhandSoft-Regular.ttf) format('truetype');
}
/* BOLD */
@supports not (-ms-high-contrast: none) {
  /* Non-IE styles */
  @font-face {
    font-family: 'AkhandSoft';
    font-weight: 500;
    src: url(fonts/AkhandSoft-Semibold.otf) format('truetype');
  }
}
@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'AkhandSoft';
  src: url(fonts/AkhandSoft-Semibold.ttf) format('truetype');
  font-weight: 500;
}
/* LIGHT */
@supports not (-ms-high-contrast: none) {
  /* Non-IE styles */
  @font-face {
    font-family: 'AkhandSoft';
    font-weight: 300;
    src: url(fonts/AkhandSoft-Semilight.otf) format('truetype');
  }
}
@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'AkhandSoft';
  src: url(fonts/AkhandSoft-Semilight.ttf) format('truetype');
  font-weight: 300;
}
@font-face {
  font-family: 'AkhandSoftSemiLight';
  font-weight: normal;
  src: url(fonts/AkhandSoft-Semilight.otf) format('truetype');
}

#app {
  font-family: 'AkhandSoft', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: 7vw;
  padding-right: 7vw;
  padding-top: 11vh;
  padding-bottom: 11vh;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
html {
  height: 100%;
  font-family: AkhandSoft;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
@supports (-moz-appearance: none) {
  h1,
  h2,
  h3,
  h4 {
    font-weight: 500;
  }
}

h1,
h2,
h3,
h4 {
  margin: 0;
}
h3 {
  font-weight: 100;
}
h2 {
  text-transform: uppercase;
  font-size: 35px;
}
.back:hover {
  border: 1px solid black;
}
@media (max-width: 1280px) {
  /* #app {
      padding-right: 120px;
      padding-left: 120px;
      padding-top: 11%;
      padding-bottom: 19%;
    } */
  h2 {
    text-transform: uppercase;
    font-size: 20px;
  }
}
</style>
